import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "@/data/products";

export default function ProductsShowcase() {
  return (
    <section id="brands" className="relative bg-neutral-950 text-white py-24 lg:py-32" data-testid="products-showcase">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="eyebrow text-gold-400 mb-4">Our Brands</div>
            <h2 className="font-display font-bold text-4xl lg:text-6xl tracking-tighter max-w-3xl">
              Five brands.<br />
              <span className="gold-gradient-text">One promise of excellence.</span>
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md leading-relaxed">
            From premium malt to zero-sugar cola, functional energy to naturally pure water — every SBC brand is engineered for delight.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`${i === 0 ? "md:col-span-2" : ""} group relative overflow-hidden rounded-3xl bg-gradient-to-br ${p.accentBg} min-h-[420px] flex flex-col justify-end p-8 cursor-pointer`}
            >
              <div className="absolute inset-0 opacity-40 group-hover:opacity-60 transition-opacity">
                <img src={p.board} alt={p.name} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/40 to-transparent" />
              </div>
              <div className="relative z-10 space-y-3">
                <div className="text-[10px] uppercase tracking-[0.24em] text-white/70">{p.highlight}</div>
                <h3 className="font-display font-black text-4xl lg:text-5xl leading-none">{p.name}</h3>
                <p className="text-sm text-white/80 max-w-md">{p.tagline}</p>
                <Link to={`/brands/${p.slug}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-gold-300 hover:text-gold-200 transition-colors mt-3" data-testid={`brand-card-${p.slug}`}>
                  Discover {p.name} <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
